"use client";

import React from "react";
import { Search, BookOpen, Lightbulb, Target } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MasterYourMarketing() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: searchRef,
    isVisible: isSearchVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: featuresRef,
    isVisible: isFeaturesVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  const features = [{
    icon: <BookOpen className="w-5 h-5 text-primary" />,
    text: "Trading Academy"
  }, {
    icon: <Target className="w-5 h-5 text-chart-2" />,
    text: "Instant Execution"
  }, {
    icon: <Lightbulb className="w-5 h-5 text-primary" />,
    text: "Market Insights"
  }];
  return <section data-section-id="117704" id="master-the-markets" className="relative overflow-hidden bg-background py-24 lg:py-32 flex flex-col items-center justify-center min-h-[80vh] dark">
      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-[10%] -left-[10%] w-[50%] h-[50%] rounded-full bg-primary/10 blur-[120px] mix-blend-multiply dark:mix-blend-screen" />
        <div className="absolute top-[20%] -right-[10%] w-[40%] h-[60%] rounded-full bg-chart-2/10 blur-[120px] mix-blend-multiply dark:mix-blend-screen" />
        <div className="absolute -bottom-[20%] left-[20%] w-[60%] h-[40%] rounded-full bg-primary/5 blur-[100px] mix-blend-multiply dark:mix-blend-screen" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6 max-w-5xl">
        <div ref={headerRef} className={`text-center transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-sm bg-card/80 text-primary text-sm font-medium mb-6 border border-border">
            <span className="flex h-2 w-2 rounded-full bg-primary animate-pulse"></span>
            TradeSphere Terminal
          </div>
          <h1 className="text-5xl md:text-7xl font-bold tracking-tighter text-foreground mb-6 font-sans leading-tight">
            Trade Smarter, <br className="hidden md:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-chart-2">
              Not Harder
            </span>
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-12 leading-relaxed">
            Access institutional-grade liquidity, real-time execution speeds, and advanced analytics designed to empower your financial decisions.
          </p>
        </div>

        {}
        <div ref={searchRef} className={`max-w-3xl mx-auto transition-all duration-1000 delay-200 ease-out ${isSearchVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-primary to-chart-2 rounded-sm blur opacity-25 group-hover:opacity-40 transition duration-500"></div>
            <div className="relative flex items-center bg-card border border-border rounded-sm p-2 shadow-2xl">
              <div className="pl-4 pr-2 text-muted-foreground">
                <Search className="w-6 h-6" />
              </div>
              <Input type="text" placeholder="Search markets: BTC/USD, AAPL, Gold..." className="flex-1 border-0 bg-transparent shadow-none focus-visible:ring-0 text-lg md:text-xl h-14 px-2 placeholder:text-muted-foreground/50 font-mono" readOnly />
              <Button size="lg" className="rounded-sm px-8 h-14 text-base font-bold shadow-lg bg-primary text-primary-foreground hover:opacity-90 transition-opacity" onClick={() => window.location.href = '/AcademyPage'}>
                Start Learning
              </Button>
            </div>
          </div>
        </div>

        {}
        <div ref={featuresRef} className={`mt-16 flex flex-wrap justify-center gap-4 md:gap-8 transition-all duration-1000 delay-400 ease-out ${isFeaturesVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {features.map((feature, i) => <div key={i} data-index={i} className="flex items-center gap-2 px-4 py-2 rounded-sm bg-card/40 border border-border/50 backdrop-blur-md shadow-sm hover:border-primary/50 transition-colors">
              {feature.icon}
              <span className="text-sm font-semibold text-foreground tracking-wide">{feature.text}</span>
            </div>)}
        </div>
      </div>
    </section>;
}